import React from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Container fluid className="footer">
      <Row>
        <footer className="footer">
          <div className="links justify-self-center gap-4 flex-wrap">
            <Link to="/about" className="link">Cine suntem?</Link>
            {/* <Link to="/donations" className="link">Donatii</Link>
            <Link to="/terms" className="link">Termeni și condiții</Link> 
            WILL BE ADDED AFTER WE HAVE DONATIONS AND FINAL VERSION IS RELEASED*/}
          </div>

          <div className="logos justify-self-right">
            <a href="https://www.instagram.com/tineriliberi/" target="_blank" rel="noopener noreferrer">
              <img src="/images/instagram.png" alt="Instagram" className="logo"/>
            </a>
            <a href="https://www.facebook.com/InitiativaTimisoara/" target="_blank" rel="noopener noreferrer">
              <img src="/images/facebook.png" alt="Facebook" className="logo"/>
            </a>
          </div>
        </footer>
      </Row>
    </Container>
  );
}

export default Footer;
